/*
  BLUE QUILL LEARNING CENTER COURSE DATA
  Edit this single file when adding, renaming, reordering or publishing lessons.
*/

window.BQA_LEARNING_CENTER_COURSES = {

  /* =========================================================
     BEGINNER FLY FISHING
     ========================================================= */

  "beginner-fly-fishing": {
    title: "Beginner Fly Fishing",
    shortTitle: "Beginner Fly Fishing",
    landingUrl: "/pages/blue-quill-learning-center",
    storageKey: "bqa-learning-progress-beginner-v3",

    modules: [

      /* =========================
         MODULE 1
         GETTING STARTED
      ========================== */

      {
        id: "module-1",
        title: "Module 1 — Getting Started",

        lessons: [
          {
            id: "what-is-fly-fishing",
            title: "What Is Fly Fishing?",
            url: "/pages/what-is-fly-fishing",
            published: true
          },
          {
            id: "basic-fly-fishing-terminology",
            title: "Basic Fly Fishing Terminology",
            url: "/pages/basic-fly-fishing-terminology",
            published: true
          },
          {
            id: "equipment-overview",
            title: "Equipment Overview",
            url: "/pages/fly-fishing-equipment-overview",
            published: true
          },
          {
            id: "leaders-tippet-and-basic-rigging",
            title: "Leaders, Tippet and Basic Rigging",
            url: "/pages/leaders-tippet-and-basic-rigging",
            published: true
          },
          {
            id: "essential-fly-fishing-knots",
            title: "Essential Fly-Fishing Knots",
            url: "/pages/essential-fly-fishing-knots",
            published: true
          }
        ]
      },

      /* =========================
         MODULE 2
         FLIES AND WHAT FISH EAT
      ========================== */

      {
        id: "module-2",
        title: "Module 2 — Flies and What Fish Eat",

        lessons: [
          {
            id: "dry-flies-nymphs-and-streamers",
            title: "Dry Flies, Nymphs and Streamers",
            url: "/pages/dry-flies-nymphs-and-streamers",
            published: true
          },
          {
            id: "basic-trout-food-and-insects",
            title: "Basic Trout Food and Insects",
            url: "/pages/basic-trout-food-and-insects",
            published: true
          },
          {
            id: "how-trout-feed",
            title: "How Trout Feed",
            url: "/pages/how-trout-feed",
            published: true
          },
          {
            id: "choosing-the-right-fly",
            title: "Choosing the Right Fly",
            url: "/pages/choosing-the-right-fly",
            published: true
          }
        ]
      },

      /* =========================
         MODULE 3
         CASTING AND PRESENTATION
      ========================== */

      {
        id: "module-3",
        title: "Module 3 — Casting and Presentation",

        lessons: [
          {
            id: "essential-fly-casting",
            title: "Essential Fly Casting",
            url: "/pages/essential-fly-casting",
            published: true
          },
          {
            id: "roll-casting-and-presentation-casts",
            title: "Roll Casting and Presentation Casts",
            url: "/pages/roll-casting-and-presentation-casts",
            published: true
          },
          {
            id: "line-management-and-mending",
            title: "Line Management and Mending",
            url: "/pages/line-management-and-mending",
            published: true
          },
          {
            id: "the-dead-drift",
            title: "The Dead Drift",
            url: "/pages/the-dead-drift",
            published: true
          }
        ]
      }

    ]
  },


  /* =========================================================
     FLY TYING ACADEMY
     LEVEL 1 — BEGINNER FLY TYER
     ========================================================= */

  "beginner-fly-tyer": {
    title: "Beginner Fly Tyer",
    shortTitle: "Beginner Fly Tyer",
    landingUrl: "/pages/blue-quill-learning-center",
    storageKey: "bqa-learning-progress-beginner-fly-tyer-v1",

    modules: [

      /* =========================
         MODULE 1
         FLY TYING FOUNDATIONS
      ========================== */

      {
        id: "module-1",
        title: "Module 1 — Fly Tying Foundations",

        lessons: [
          {
            id: "welcome-to-fly-tying",
            title: "Welcome to Fly Tying",
            url: "/pages/welcome-to-fly-tying",
            published: true
          },
          {
            id: "essential-fly-tying-tools",
            title: "Essential Fly Tying Tools",
            url: "/pages/essential-fly-tying-tools",
            published: true
          },
          {
            id: "understanding-fly-tying-hooks",
            title: "Understanding Fly Tying Hooks",
            url: "/pages/understanding-fly-tying-hooks",
            published: true
          },
          {
            id: "understanding-fly-tying-thread",
            title: "Understanding Fly Tying Thread",
            url: "/pages/understanding-fly-tying-thread",
            published: true
          },
          {
            id: "introduction-to-fly-tying-materials",
            title: "Introduction to Fly Tying Materials",
            url: "/pages/introduction-to-fly-tying-materials",
            published: true
          },
          {
            id: "starting-and-controlling-your-thread",
            title: "Starting and Controlling Your Thread",
            url: "/pages/starting-and-controlling-your-thread",
            published: true
          },
          {
            id: "the-pinch-wrap",
            title: "The Pinch Wrap",
            url: "/pages/the-pinch-wrap",
            published: true
          },
          {
            id: "securing-and-trimming-materials",
            title: "Securing and Trimming Materials",
            url: "/pages/securing-and-trimming-materials",
            published: true
          },
          {
            id: "building-a-clean-fly",
            title: "Building a Clean Fly",
            url: "/pages/building-a-clean-fly",
            published: true
          },
          {
            id: "finishing-a-fly",
            title: "Finishing a Fly",
            url: "/pages/finishing-a-fly",
            published: true
          }
        ]
      },

      /* =========================
         MODULE 2
         YOUR FIRST FLIES
      ========================== */

      {
        id: "module-2",
        title: "Module 2 — Your First Flies",

        lessons: [
          {
            id: "san-juan-worm",
            title: "San Juan Worm",
            url: "/pages/how-to-tie-a-san-juan-worm",
            published: true
          },
          {
            id: "zebra-midge",
            title: "Zebra Midge",
            url: "/pages/how-to-tie-a-zebra-midge",
            published: true
          },
          {
            id: "walts-worm",
            title: "Walt's Worm",
            url: "/pages/how-to-tie-walts-worm",
            published: true
          },
          {
            id: "pheasant-tail-nymph",
            title: "Pheasant Tail Nymph",
            url: "/pages/how-to-tie-a-pheasant-tail-nymph",
            published: true
          },
          {
            id: "hares-ear-nymph",
            title: "Hare's Ear Nymph",
            url: "/pages/how-to-tie-a-hares-ear-nymph",
            published: true
          },
          {
            id: "woolly-bugger",
            title: "Woolly Bugger",
            url: "/pages/how-to-tie-a-woolly-bugger",
            published: true
          }
        ]
      }

    ]
  }

};